import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: [],
  unreadCount: 0,
  lastUpdate: null,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    /**
     * Ajouter une nouvelle notification
     */
    addNotification: (state, action) => {
      const newNotification = {
        id: Date.now() + Math.random(),
        ...action.payload,
        read: false,
        createdAt: new Date().toISOString(),
      };
      
      state.notifications.unshift(newNotification);
      state.unreadCount += 1;
      state.lastUpdate = new Date().toISOString();
      
    },

    /**
     * Marquer une notification comme lue
     */
    markAsRead: (state, action) => {
      const notification = state.notifications.find(
        (n) => n.id === action.payload
      );
      
      if (notification && !notification.read) {
        notification.read = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
        state.lastUpdate = new Date().toISOString();
        
      }
    },

    /**
     * Marquer toutes les notifications comme lues
     */
    markAllAsRead: (state) => {
      state.notifications.forEach((n) => {
        n.read = true;
      });
      state.unreadCount = 0;
      state.lastUpdate = new Date().toISOString();
      
    },

    /**
     * Supprimer une notification
     */
    removeNotification: (state, action) => {
      const index = state.notifications.findIndex(
        (n) => n.id === action.payload
      );
      
      if (index !== -1) {
        const wasUnread = !state.notifications[index].read;
        state.notifications.splice(index, 1);
        
        if (wasUnread) {
          state.unreadCount = Math.max(0, state.unreadCount - 1);
        }
        
        state.lastUpdate = new Date().toISOString();
      }
    },

    /**
     * Supprimer toutes les notifications
     */
    clearAllNotifications: (state) => {
      state.notifications = [];
      state.unreadCount = 0;
      state.lastUpdate = new Date().toISOString();
      
    },

    /**
     * Supprimer les notifications d'un type spécifique
     */
    clearNotificationsByType: (state, action) => {
      const type = action.payload;
      const beforeCount = state.notifications.length;
      
      state.notifications = state.notifications.filter(
        (n) => n.type !== type
      );
      
      // Recalculer unreadCount
      state.unreadCount = state.notifications.filter(n => !n.read).length;
      state.lastUpdate = new Date().toISOString();
      
      const removedCount = beforeCount - state.notifications.length;
    },

    /**
     * Définir les notifications (remplace toutes les notifications)
     */
    setNotifications: (state, action) => {
      state.notifications = action.payload.map(n => ({
        ...n,
        id: n.id || Date.now() + Math.random(),
        read: n.read || false,
      }));
      state.unreadCount = state.notifications.filter(n => !n.read).length;
      state.lastUpdate = new Date().toISOString();
      
    },

    /**
     * Mettre à jour le compteur non lu
     */
    updateUnreadCount: (state) => {
      state.unreadCount = state.notifications.filter(n => !n.read).length;
    },
  },
});

export const {
  addNotification,
  markAsRead,
  markAllAsRead,
  removeNotification,
  clearAllNotifications,
  clearNotificationsByType,
  setNotifications,
  updateUnreadCount,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
